import { applySnapshot, Instance, SnapshotIn, SnapshotOut, flow, types } from 'mobx-state-tree';

import { utils, track } from 'lib';
import { globalStore } from 'stores';

const initState = {
  loginType: 'password', // mobile  password  register
  isRemember: false,
  mobile: '', //
  code: '',
  userName: '',
  password: '',
};

export const Model = types
  .model('PopupLoginModel', {
    loginType: '',
  })
  .actions((self) => {
    const toggleLoginType = () => {
      self.loginType = self.loginType === 'mobile' ? 'password' : 'mobile';
    };
    // type:  'mobile' | 'password' | 'register'
    const setLoginType = (type) => {
      track.send({
        event: 'userLogin',
        event_type: 'setLoginType',
        content: {
          loginType: type,
          isUserInfoReady: globalStore.isUserInfoReady,
          isLogin: globalStore.isLogin,
          userId: globalStore.userId,
        },
      });
      self.loginType = type;
    };
    return {
      toggleLoginType,
      setLoginType,
    };
  });

export default {
  initState,
  Model,
};
